import { CSSProperties } from 'react';

export const styles: Record<string, CSSProperties> = {
  // Position + clip are forced (spread after the caller's style) so the
  // cursor highlight always renders and stays inside the button.
  button: {
    position: 'relative',
    overflow: 'hidden',
    isolation: 'isolate',
  },
  reflection: {
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    pointerEvents: 'none',
    transition: 'opacity 0.25s ease',
    zIndex: 0,
  },
  content: {
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
  },
};
